import {Component, trigger, transition, style, animate, state} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';


import { STATIC_VALUE } from './../../configuration/static.value';
import { ProfileService } from './../../../profile/services/profile.service';
import { PopupService } from './../../services/pop-up.service';

@Component({
    selector: 'pop-up-change-security-question',
    templateUrl: 'change-security-question-popup.component.html',
    animations: [
    trigger(
      'popupAnimation',
      [
        transition(
        ':enter', [
          style({opacity: 0}),
          animate('300ms', style({'opacity': 1}))
        ]
      ),
      transition(
        ':leave', [
          style({'opacity': 1}),
          animate('300ms', style({'opacity': 0}))
        ]
      )]
    )
  ],
})

export class ChangeSecurityQuestionPopupComponent {

    constructor(
        private _popupService: PopupService,
        private _profileService: ProfileService
    ) {

    }

    ngOnInit(){
        this._profileService.resetChangeSecurityData();
    }

    getPopupOption() {
        return this._popupService.popUpOptions;
    }

    getChangeSecurityQuestionFlag() {
        return this._popupService.getChangeSecurityQuestionFlag();
    }

    getChangeSecurityData(){
        return this._profileService.getChangeSecurityData();
    }

    getSecurityQuestionList() {
		return STATIC_VALUE.SECURITY_QUESTION_LIST;
    }

    isDisableSubmit(){
        return this._profileService.isDisableChangeSecurity();
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/components/popup/change-security-question-popup.component.ts